import { useI18nContext } from '../contexts/I18nContext'

export const useI18n = () => {
  return useI18nContext()
} 